export default __webpack_public_path__ + "static/media/preparing_home.29c3ac63.svg";